import { useEffect } from 'react';
import toast from 'react-hot-toast';

import { useSearchParams } from '@remix-run/react';
import { pickBy } from 'es-toolkit';

const useRedirectToasts = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get('toast');
  const message = searchParams.get('message');
  const title = searchParams.get('title');
  const toastId = searchParams.get('toastId');

  // Render toast and then delete the query params
  useEffect(() => {
    if (status && message) {
      const toastMessage = `${title ? `${title}\n` : ''}${message}`;
      const toastOptions = pickBy({ id: toastId || undefined }, (value) => value !== undefined);
      status === 'success' ? toast.success(toastMessage, toastOptions) : toast.error(toastMessage, toastOptions);
      searchParams.delete('toast');
      searchParams.delete('message');
      searchParams.delete('title');
      searchParams.delete('toastId');
      setSearchParams(searchParams, { replace: true });
    }
  }, [status, message, title, toastId, searchParams, setSearchParams]);
};

export default useRedirectToasts;
